import { createModalStore } from '@/shared/lib/modal';

export const useTrialPricingModalStore = createModalStore<Record<string, never>>({}, false);
